export default {"src":"/_next/static/media/arrow-hover.aa295c1f.svg","height":17,"width":25};